export class Representative {
	id: number;
	name: string;
	created_at: string;
	updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/representative.ts